<template>
  <component :is="component" />
</template>

<script>
import noQuotaOrderCheck from '../components/noQuotaOrderCheck.vue'
import noQuotaOrderEdit from '../noQuotaOrderEdit.vue'
export default {
  components: {
    noQuotaOrderCheck,
    noQuotaOrderEdit
  },
  data() {
    return {
      component: 'noQuotaOrderCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'noQuotaOrderCheck' : 'noQuotaOrderEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order-manage/check/noQuotaOrderCheck.vue